import { refreshArobaToken } from './aroba.service';
import { handleCognitoError, refreshTokenCognito } from './cognito.service';

export function refreshTokens() {
  return Promise.all([
    refreshTokenCognito()
      .then(({ error }) => {
        if (error) {
          throw error;
        }
      })
      .catch((error) => handleCognitoError(error)),
    refreshArobaToken(),
  ]);
}
